<div class="onoffswitch-wrapGeneral">
  <div class="onoffswitch-wrap checked">
    <!-- <div class="onoffswitch">
      <input type="checkbox" name="onoffswitch03" id="myonoffswitch03" class="onoffswitch-checkbox" checked>
      <label class="onoffswitch-label" for="myonoffswitch03"></label>
    </div>
    <label class="onoffswitch-label-text" for="myonoffswitch03">Mostrar entradas</label> -->
  </div>
</div>

<div class="map-ubicacion" style="display: none">
  <!-- MINIMAPA -->
  <div class="ImageWrap">
    <div
      width="460px"
      style="width: 460px; display: inline-block; max-width: 460px"
    ></div>
    <!-- <img src="assets/img/TMP-asientos.jpg" alt="mapa asientos"> -->
    <div class="zoomBox" style="top: 49%; left: 48%"></div>
  </div>
  <!-- CONTROLES -->
  <div class="controls">
    <div class="Zooms">
      <span class="btn">
        <img
          class="svg"
          src="assets/img/icon-zoom-in.svg"
          (click)="mapa.zoomIn()"
          alt="icono zoom in"
        />
      </span>
      <span class="btn">
        <img
          class="svg"
          src="assets/img/icon-zoom-out.svg"
          (click)="mapa.zoomOut()"
          alt="icono zoom out"
        />
      </span>
    </div>
    <div class="position">
      <span id="top-left" class="btn diag">
        <img
          class="svg"
          src="assets/img/icon-arrow-diag.svg"
          (click)="mapa.diagonalTopLeft()"
          alt="icono diagonal"
        />
      </span>
      <span id="top" class="btn">
        <img
          class="svg"
          src="assets/img/icon-arrow-rect.svg"
          (click)="mapa.panUp()"
          alt="icono enlinea"
        />
      </span>
      <span id="top-right" class="btn diag">
        <img
          class="svg"
          src="assets/img/icon-arrow-diag.svg"
          (click)="mapa.diagonalTopRight()"
          alt="icono diagonal"
        />
      </span>
      <span id="left" class="btn">
        <img
          class="svg"
          src="assets/img/icon-arrow-rect.svg"
          (click)="mapa.panLeft()"
          alt="icono enlinea"
        />
      </span>
      <span class="btn">
        <img
          class="svg"
          src="assets/img/icon-refresh.svg"
          (click)="mapa.reset()"
          alt="icono refresh"
        />
      </span>
      <span id="right" class="btn">
        <img
          class="svg"
          src="assets/img/icon-arrow-rect.svg"
          (click)="mapa.panRight()"
          alt="icono enlinea"
        />
      </span>
      <span id="bottom-left" class="btn diag">
        <img
          class="svg"
          src="assets/img/icon-arrow-diag.svg"
          (click)="mapa.diagonalBottomLeft()"
          alt="icono diagonal"
        />
      </span>
      <span id="down" class="btn">
        <img
          class="svg"
          src="assets/img/icon-arrow-rect.svg"
          (click)="mapa.panDown()"
          alt="icono enlinea"
        />
      </span>
      <span id="bottom-right" class="btn diag">
        <img
          class="svg"
          src="assets/img/icon-arrow-diag.svg"
          (click)="mapa.diagonalBottomRight()"
          alt="icono diagonal"
        />
      </span>
    </div>
  </div>
</div>

<!-- MAPA -->
<div id="asientos" class="asientos">
  <ticketing-mapa #mapa></ticketing-mapa>
</div>
<div class="leyenda">
  <div
    class="tipo-butaca"
    *ngFor="let legend of filtroLeyenda"
  >
    <div class="cuadro-tipo" [style.background]="legend.Color"></div>
    <div class="tipo-butaca">{{ legend.Descripcion }}</div>
  </div>
</div>
<br />
